// ============================================
// Creator State - Lorebook (Zustand 기반)
// 로어북 상태 관리
// ============================================

import { useCreatorStore, MAX_LOREBOOK_ENTRIES } from '../../../stores/creatorStore.js';

export { MAX_LOREBOOK_ENTRIES };

// Getters
export const getLorebookEntries = () => useCreatorStore.getState().lorebookEntries;
export const getEditingLorebookIndex = () => useCreatorStore.getState().editingLorebookIndex;

// Setters
export function setLorebookEntries(entries) {
  useCreatorStore.getState().setLorebookEntries(entries);
}

export function addLorebookEntry(entry) {
  useCreatorStore.getState().addLorebookEntry(entry);
}

export function updateLorebookEntry(index, entry) {
  useCreatorStore.getState().updateLorebookEntry(index, entry);
}

export function removeLorebookEntry(index) {
  useCreatorStore.getState().removeLorebookEntry(index);
}

export function setEditingLorebookIndex(index) {
  useCreatorStore.getState().setEditingLorebookIndex(index);
}
